import { GroupingError } from '@/store/modules/stay/types'

export function hasCriticalError(groupingErrors: GroupingError[] | null) {
  return groupingErrors?.some((error) => error.critical)
}